import { REPORT_TYPES, SET_REPORTS_SEARCH_PARAMS } from 'src/actions/actionType'
import { INITIAL_REPORTS_SEARCH_PARAMS } from 'src/views/reports/partials/Constants'

const initialState = {
  searchParams: INITIAL_REPORTS_SEARCH_PARAMS,
  reportTypes: [],
}

export default function ReportsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_REPORTS_SEARCH_PARAMS:
      return {
        ...state,
        searchParams: action.payload,
      }
    case REPORT_TYPES:
      return { ...state, reportTypes: action.payload }
    default:
      return state
  }
}
